export default {
      id: "pattern-plus-left-cropped-2-usage",
      viewBox: "0 0 157 158",
      url: "../icon/" + "icons.svg#pattern-plus-left-cropped-2-usage",
      toString: function () {
        return this.url;
      }
    }